import { useEffect } from "react";
function ForgottenPasswordPage() {
    useEffect(() => {
        // Password reset is handled by Keycloak — redirect to login page
        window.location.href = "/auth/login";
    }, []);
    return null;
}
export default ForgottenPasswordPage;
